import { ModalExitIntentContainer } from '@hungryroot/modal-exit-intent';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const ModalExitIntentIsland = islandRoot(ModalExitIntentContainer);
